import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
const { REACT_APP_API_KEY } = process.env;

const useAddClinic = ({ clinicInfo = {} }) => {
  const [isAddClinicLoading, setIsAddClinicLoading] = useState(false);

  const onAddNewClinic = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!clinicInfo.name) {
      toast.error("Clinic name is required");
      return;
    }
    
    setIsAddClinicLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      await axios.post(
        `/api/v1/clinic`,
        {
          name: clinicInfo?.name,
          address: clinicInfo?.address,
          phoneNumber: clinicInfo?.phoneNumber,
          email: clinicInfo?.email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      toast.success("Clinic added successfully");
    } catch (error) {
      console.error(error);
      toast.error("Error adding clinic");
    } finally {
      setIsAddClinicLoading(false);
    }
  };

  return {
    isAddClinicLoading,
    onAddNewClinic,
  };
};

export default useAddClinic; 